<template>
  <div class="modalbox-content similares-container">
    <div class="manual-header">
      <div class="search-wrapper">
        <fa-icon icon="search" class="search-icon" />
        <input
          class="form-control"
          v-model="searchTerm"
          placeholder="Buscar por código ou descrição..."
          @input="debounceSearch"
        />
      </div>
      <span class="selected-counter">
        <strong>{{ (item.similares || []).length }}</strong> selecionados
      </span>
    </div>

    <div v-if="searchLoading" class="loading-indicator">
      <fa-icon icon="spinner" spin /> Buscando...
    </div>

    <div v-else-if="displayedProducts.length > 0" class="produto-list">
      <div class="produto-list-header">
        <div class="pl-check"></div>
        <div class="pl-img">Imagem</div>
        <div class="pl-info">Produto</div>
      </div>
      <div
        v-for="produto in displayedProducts"
        :key="'pl-' + produto.id"
        class="produto-row"
        :class="{ selected: jaAdicionado(produto.id) }"
        @click="toggleProduto(produto)"
      >
        <div class="pl-check">
          <input
            type="checkbox"
            :checked="jaAdicionado(produto.id)"
            @click.stop="toggleProduto(produto)"
          />
        </div>
        <div class="pl-img">
          <div class="pl-thumb">
            <img :src="getImageUrl(produto.id)" :alt="produto.descComp || produto.descNF" />
          </div>
        </div>
        <div class="pl-info">
          <div class="pl-name">{{ produto.descComp || produto.descNF }}</div>
          <div class="pl-id">ID: {{ produto.id }}</div>
        </div>
      </div>
    </div>

    <div v-else-if="searchTerm && searchTerm.length >= 2" class="manual-empty">
      <div class="empty-icon"><fa-icon icon="inbox" /></div>
      <p>Nenhum produto encontrado</p>
    </div>

    <div v-else class="manual-empty">
      <div class="empty-icon"><fa-icon icon="cubes" /></div>
      <p v-if="(item.similares || []).length === 0">Busque produtos para adicionar como similares</p>
      <p v-else>Nenhum produto na busca. {{ (item.similares || []).length }} similar(es) selecionado(s).</p>
    </div>
  </div>
</template>

<script>
import { get } from "@/helpers/apiRequest";
import { cdnUrlProduto } from "@/helpers/url";

let searchTimeout = null;

export default {
  name: "Similares",
  props: {
    item: { type: Object, required: true },
  },
  data() {
    return {
      searchTerm: "",
      searchResults: [],
      searchLoading: false,
    };
  },
  computed: {
    displayedProducts() {
      if (this.searchTerm && this.searchTerm.length >= 2 && this.searchResults.length > 0) {
        return this.searchResults;
      }
      return this.item.similares || [];
    },
  },
  methods: {
    debounceSearch() {
      if (searchTimeout) clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        this.searchProdutos();
      }, 350);
    },
    searchProdutos() {
      if (!this.searchTerm || this.searchTerm.length < 2) {
        this.searchResults = [];
        return;
      }
      this.searchLoading = true;
      // filtros[q] busca por id OU codigoreferencia OU descricaocompleta (backend ProdutoCriteria)
      get(`/admin/produtos?filtros[q]=${encodeURIComponent(this.searchTerm.trim())}&page=1`)
        .then((json) => {
          this.searchResults = json.itens || [];
          this.searchLoading = false;
        })
        .catch(() => {
          this.searchResults = [];
          this.searchLoading = false;
        });
    },
    jaAdicionado(id) {
      return (this.item.similares || []).some((s) => s.id === id);
    },
    toggleProduto(produto) {
      if (this.jaAdicionado(produto.id)) {
        this.removeSimilar(produto.id);
      } else {
        this.addSimilar(produto);
      }
    },
    addSimilar(produto) {
      if (!this.jaAdicionado(produto.id)) {
        this.item.similares.push(produto);
      }
    },
    removeSimilar(id) {
      this.item.similares = this.item.similares.filter((s) => s.id !== id);
    },
    getImageUrl(id) {
      return cdnUrlProduto(id);
    },
  },
};
</script>

<style scoped>
.similares-container {
  padding: 12px 0;
}

/* Search header */
.manual-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.search-wrapper {
  position: relative;
  flex: 1;
  max-width: 400px;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #98a2b3;
  font-size: 14px;
}

.search-wrapper .form-control {
  padding-left: 36px;
  border-radius: 8px;
}

.selected-counter {
  font-size: 13px;
  color: #667085;
  font-weight: 500;
  white-space: nowrap;
}

.selected-counter strong {
  color: #3a3e81;
}

.loading-indicator {
  text-align: center;
  padding: 20px;
  color: #98a2b3;
  font-size: 13px;
}

/* Product list */
.produto-list {
  border: 1px solid #e9ecef;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  max-height: 400px;
  overflow-y: auto;
}

.produto-list-header {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  background: #f9fafb;
  border-bottom: 1px solid #e9ecef;
  font-size: 12px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  position: sticky;
  top: 0;
  z-index: 1;
}

.pl-check { flex: 0 0 40px; }
.pl-img { flex: 0 0 80px; }
.pl-info { flex: 1; }

.produto-row {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  border-bottom: 1px solid #f2f4f7;
  cursor: pointer;
  transition: background 0.1s;
}

.produto-row:last-child { border-bottom: none; }
.produto-row:hover { background: #f9fafb; }

.produto-row.selected {
  background: #f2f2f8;
}

.produto-row .pl-check input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #3a3e81;
}

.pl-thumb {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: #f9fafb;
  border: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.pl-thumb img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.pl-name {
  font-weight: 600;
  font-size: 13px;
  color: #1d2939;
  line-height: 1.3;
  margin-bottom: 2px;
}

.pl-id {
  font-size: 12px;
  color: #98a2b3;
}

/* Empty states */
.manual-empty {
  text-align: center;
  padding: 30px 20px;
  color: #98a2b3;
}

.manual-empty .empty-icon {
  font-size: 28px;
  color: #d0d5dd;
  margin-bottom: 8px;
}

.manual-empty p {
  font-size: 13px;
  margin: 0;
}
</style>
